import React from 'react';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './BancoAutoPesadoDesktop.css';

function BancoAutoPesadoDesktop() {
  return (
    <section id="banco-do-auto-pesado-desktop" className="desktop">
      <ContainerHome24 className="container-pesado">
        <img
          className="banco-do-auto-imagem"
          src="assets/banco-do-auto25/carro-escudo.svg"
          alt="ilustração carro"
        />
        <div>
          <h3 className="pesado-title">
            Seguro avulso para seu veículo <b>novo e usado</b>
          </h3>
          <p className="pesado-paragrafo">
            Conheça mais informações sobre como funciona o nosso <b>seguro para pesados.</b>
          </p>
          <a
            className="link-banco-do-auto-pesado"
            href="seguro-santander-auto.html"
            target="_blank"
          >
            Consultar
          </a>
        </div>
        <style jsx>{Styles}</style>
      </ContainerHome24>
    </section>
  );
}

export default BancoAutoPesadoDesktop;
